import { asPartialDef } from "../coerce";
import type { BlockPlugin, GradeResult, ValidationResult } from "../types";

export interface MatchPair {
  left: string;
  right: string;
}

export interface MatchDef {
  pairs: MatchPair[];
}

export interface MatchResponse {
  /** Emparejamientos propuestos por el alumno. */
  matches: MatchPair[];
}

export const matchBlock: BlockPlugin<MatchDef, MatchResponse> = {
  type: "match",
  interaction: "match",
  autoGradable: true,

  validate(def: unknown): ValidationResult<MatchDef> {
    const d = asPartialDef<MatchDef>(def);
    if (!d || !Array.isArray(d.pairs) || d.pairs.length < 2) {
      return { ok: false, errors: ["match: al menos 2 `pairs`"] };
    }
    for (const p of d.pairs) {
      if (!p || typeof p.left !== "string" || typeof p.right !== "string") {
        return { ok: false, errors: ["match: cada par requiere `left` y `right` string"] };
      }
    }
    return { ok: true, def: { pairs: d.pairs } };
  },

  grade(def: MatchDef, response: MatchResponse | undefined): GradeResult {
    // Clave canónica del par correcto.
    const correct = new Set(def.pairs.map((p) => `${p.left} ${p.right}`));
    const seen = new Set<string>();
    let hits = 0;
    for (const m of response?.matches ?? []) {
      const key = `${m.left} ${m.right}`;
      if (correct.has(key) && !seen.has(key)) {
        hits += 1;
        seen.add(key);
      }
    }
    const total = def.pairs.length;
    const score = total === 0 ? 0 : hits / total;
    return { correct: hits === total, score, maxScore: 1, revealed: def.pairs };
  },
};
